/**
 * Property Map Module
 *
 * Renders an OpenStreetMap using Leaflet.js for property locations.
 *
 * @package TheRealEstates
 */

import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

export default class PropertyMap {
  constructor() {
    this.mapContainer = document.getElementById('property-map');

    if (!this.mapContainer) return;

    this.lat = parseFloat(this.mapContainer.dataset.lat);
    this.lng = parseFloat(this.mapContainer.dataset.lng);

    if (isNaN(this.lat) || isNaN(this.lng)) return;

    this.map = null;
    this.marker = null;

    this.init();
  }

  init() {
    // Remove placeholder
    const placeholder = this.mapContainer.querySelector('.property-map__placeholder');
    if (placeholder) {
      placeholder.style.display = 'none';
    }

    // Initialize map
    this.map = L.map(this.mapContainer, {
      center: [this.lat, this.lng],
      zoom: 15,
      scrollWheelZoom: false,
      zoomControl: true,
    });

    // Add OpenStreetMap tiles with elegant styling
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 19,
    }).addTo(this.map);

    // Create custom marker icon
    const customIcon = L.divIcon({
      className: 'property-map__marker',
      html: `
        <div class="property-map__marker-pin">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
          </svg>
        </div>
        <div class="property-map__marker-pulse"></div>
      `,
      iconSize: [48, 48],
      iconAnchor: [24, 48],
    });

    // Add marker
    this.marker = L.marker([this.lat, this.lng], { icon: customIcon }).addTo(this.map);

    // Enable scroll wheel zoom on click
    this.mapContainer.addEventListener('click', () => {
      this.map.scrollWheelZoom.enable();
    });

    // Disable scroll wheel zoom when mouse leaves
    this.mapContainer.addEventListener('mouseleave', () => {
      this.map.scrollWheelZoom.disable();
    });
  }

  destroy() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  }
}
